export default "__VITE_ASSET__Cvm87sDR__"